<template>
  <a-modal v-model="showModal" class="mobile-modal-fullscreen q-answer-modal" :footer="null" :closable="true" :width="600" @cancel="hide">
    <!-- <font-awesome-icon :icon="['fal', 'times']" class="show-in-mobile font-black font20 position-absolute" @click="hide" /> -->
    <!-- <font-awesome-icon :icon="['fal', 'times']" class="cp hide-in-mobile font-black font20 position-absolute gray400" @click="hide" :style="{ top: '30px', right: '30px' }" /> -->
    <a-tabs v-model="activeKey" v-if="showModal" :tabBarStyle="{ '--P500C': getPrimaryColor().split(' ')[0] }" class="mt-3">
      <a-tab-pane key="all" :tab="`All (${allCount})`">
        <SimpleLoader v-if="loadingAll" />
        <template v-else-if="allList.length">
          <NameCard v-for="user in allList" :key="user" :user="user" />
        </template>
        <p v-else class="m-4 text-center">No Results</p>
      </a-tab-pane>
      <template v-if="reactionType === 'agree'">
        <a-tab-pane key="doctor" :tab="`Physicians (${doctorCount})`">
          <SimpleLoader v-if="loadingPhysician" />
          <template v-else-if="doctorList.length">
            <NameCard v-for="user in doctorList" :key="user" :user="user" />
          </template>
          <p v-else class="m-4 text-center">No Results</p>
        </a-tab-pane>
        <a-tab-pane key="hcp" :tab="`Advanced Practice Providers (${HCPCount})`">
          <SimpleLoader v-if="loadingHCP" />
          <template v-else-if="HCPList.length">
            <NameCard v-for="user in HCPList" :key="user" :user="user" />
          </template>
          <p v-else class="m-4 text-center">No Results</p>
        </a-tab-pane>
      </template>
      <template v-else-if="reactionType === 'useful'">
        <a-tab-pane key="patient" :tab="`Patients (${patientCount})`">
          <SimpleLoader v-if="loadingPatient" />
          <template v-else-if="patientList.length">
            <NameCard v-for="user in patientList" :key="user" :user="user" />
          </template>
          <p v-else class="m-4 text-center">No Results</p>
        </a-tab-pane>
        <a-tab-pane key="caregiver" :tab="`Caregivers (${caregiverCount})`">
          <SimpleLoader v-if="loadingCaregiver" />
          <template v-else-if="caregiverList.length">
            <NameCard v-for="user in caregiverList" :key="user" :user="user" />
          </template>
          <p v-else class="m-4 text-center">No Results</p>
        </a-tab-pane>
        <a-tab-pane key="advocate" :tab="`Advocates (${advocateCount})`">
          <SimpleLoader v-if="loadingAdvocate" />
          <template v-else-if="advocateList.length">
            <NameCard v-for="user in advocateList" :key="user" :user="user" />
          </template>
          <p v-else class="m-4 text-center">No Results</p>
        </a-tab-pane>
        <a-tab-pane key="hospital_administrator" :tab="`Hospitals (${hospitalCount})`">
          <SimpleLoader v-if="loadingHospital" />
          <template v-else-if="hospitalList.length">
            <NameCard v-for="user in hospitalList" :key="user" :user="user" />
          </template>
          <p v-else class="m-4 text-center">No Results</p>
        </a-tab-pane>
        <a-tab-pane key="clinic_administrator" :tab="`Clinics (${clinicCount})`">
          <SimpleLoader v-if="loadingClinic" />
          <template v-else-if="clinicList.length">
            <NameCard v-for="user in clinicList" :key="user" :user="user" />
          </template>
          <p v-else class="m-4 text-center">No Results</p>
        </a-tab-pane>
        <a-tab-pane key="nfp_administrator" :tab="`NFPs (${NFPCount})`">
          <SimpleLoader v-if="loadingNFP" />
          <template v-else-if="NFPList.length">
            <NameCard v-for="user in NFPList" :key="user" :user="user" />
          </template>
          <p v-else class="m-4 text-center">No Results</p>
        </a-tab-pane>
      </template>
    </a-tabs>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import SimpleLoader from "../../commons/SimpleLoader.vue"
import NameCard from "../../reactions/NameCard.vue"

const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "AnswerReactions",
  components: { SimpleLoader, NameCard },
  props: { id: Number },
  data() {
    return {
      showModal: false,
      reactionType: "",
      activeKey: "all",
      loadingAll: false,
      loadingHCP: false,
      loadingPhysician: false,
      loadingPatient: false,
      loadingCaregiver: false,
      loadingBusiness: false,
      loadingAdvocate: false,
      loadingClinic: false,
      loadingHospital: false,
      loadingNFP: false,
      currentPage: 1,
      HCPList: [],
      businessList: [],
      hospitalList: [],
      clinicList: [],
      doctorList: [],
      NFPList: [],
      advocateList: [],
      caregiverList: [],
      patientList: [],
      allList: [],
      HCPCount: 0,
      hospitalCount: 0,
      clinicCount: 0,
      doctorCount: 0,
      businessCount: 0,
      NFPCount: 0,
      advocateCount: 0,
      caregiverCount: 0,
      patientCount: 0,
      allCount: 0,
    }
  },

  //   watch: {
  //     activeKey(v) {
  //       this.getList(v)
  //     },
  //   },
  created() {
    // console.warn(this.id, "- created -", this.reactionType)
  },

  mounted() {
    // console.warn(this.id, "- mounted -", this.reactionType)
  },

  methods: {
    async show(type) {
      // console.log("show() ->", type)
      this.showModal = true
      this.reactionType = type
      await this.getList("all")
      if (type === "agree") {
        await this.getList("doctor")
        await this.getList("hcp")
      } else {
        await this.getList("patient")
        await this.getList("caregiver")
        await this.getList("advocate")
        await this.getList("hospital_administrator")
        await this.getList("clinic_administrator")
        await this.getList("nfp_administrator")
      }
      // console.log("hcp:", this.HCPList)
      // console.log("hospital:", this.hospitalList)
      // console.log("clinic:", this.clinicList)
      // console.log("doctor:", this.doctorList)
      // console.log("nfp:", this.NFPList)
      // console.log("advocate:", this.advocateList)
      // console.log("caregiver:", this.caregiverList)
      // console.log("patient:", this.patientList)
      // console.log("all:", this.allList)
    },
    hide() {
      this.showModal = false
      this.activeKey = "all"
      this.allList = []
      this.allCount = 0
    },
    async getList(type) {
      switch (type) {
        case "app":
        case "hcp":
        case "ahcp":
        case "ohcp":
        case "other":
          this.loadingHCP = true
          const HCPres = await PostRepository.getReactionsList(2, this.id, 3, this.currentPage, 10, type, "")
          if (HCPres.data.message === "found") {
            this.HCPCount = HCPres.data.data.paginator.total_count || 0
            this.HCPList = HCPres.data.data.data
          }
          this.loadingHCP = false
          return
        case "physician":
        case "doctor":
          this.loadingPhysician = true
          const DOCres = await PostRepository.getReactionsList(2, this.id, 3, this.currentPage, 10, type, "")
          if (DOCres.data.message === "found") {
            this.doctorCount = DOCres.data.data.paginator.total_count || 0
            this.doctorList = DOCres.data.data.data
          }
          this.loadingPhysician = false
          return
        case "patient":
          this.loadingPatient = true
          const Pres = await PostRepository.getReactionsList(2, this.id, 3, this.currentPage, 10, type, "")
          if (Pres.data.message === "found") {
            this.patientCount = Pres.data.data.paginator.total_count || 0
            this.patientList = Pres.data.data.data
          }
          this.loadingPatient = false
          return
        case "advocate":
          this.loadingAdvocate = true
          const Ares = await PostRepository.getReactionsList(2, this.id, 3, this.currentPage, 10, type, "")
          if (Ares.data.message === "found") {
            this.advocateCount = Ares.data.data.paginator.total_count || 0
            this.advocateList = Ares.data.data.data
          }
          this.loadingAdvocate = false
          return
        case "caregiver":
          this.loadingCaregiver = true
          const Cres = await PostRepository.getReactionsList(2, this.id, 3, this.currentPage, 10, type, "")
          if (Cres.data.message === "found") {
            this.caregiverCount = Cres.data.data.paginator.total_count || 0
            this.caregiverList = Cres.data.data.data
          }
          this.loadingCaregiver = false
          return
        case "nfp":
        case "nfp_administrator":
          this.loadingNFP = true
          const NFPres = await PostRepository.getReactionsList(2, this.id, 3, this.currentPage, 10, type, "")
          if (NFPres.data.message === "found") {
            this.NFPCount = NFPres.data.data.paginator.total_count || 0
            this.NFPList = NFPres.data.data.data
          }
          this.loadingNFP = false
          return
        case "clinic":
        case "clinic_administrator":
          this.loadingClinic = true
          const Clres = await PostRepository.getReactionsList(2, this.id, 3, this.currentPage, 10, type, "")
          if (Clres.data.message === "found") {
            this.clinicCount = Clres.data.data.paginator.total_count || 0
            this.clinicList = Clres.data.data.data
          }
          this.loadingClinic = false
          return
        case "hospital":
        case "hospital_administrator":
          this.loadingHospital = true
          const Hores = await PostRepository.getReactionsList(2, this.id, 3, this.currentPage, 10, type, "")
          if (Hores.data.message === "found") {
            this.hospitalCount = Hores.data.data.paginator.total_count || 0
            this.hospitalList = Hores.data.data.data
          }
          this.loadingHospital = false
          return
        case "business":
        case "business_administrator":
          this.loadingBusiness = true
          const Bres = await PostRepository.getReactionsList(2, this.id, 3, this.currentPage, 10, type, "")
          if (Bres.data.message === "found") {
            this.businessCount = Bres.data.data.paginator.total_count || 0
            this.businessList = Bres.data.data.data
          }
          this.loadingBusiness = false
          return
        case "all":
          this.loadingAll = true
          if (this.reactionType === "agree") {
            const res = await PostRepository.getReactionsList(2, this.id, null, this.currentPage, 10, null, "allagree")
            if (res.data.message === "found") {
              this.allCount = res.data.data.paginator.total_count || 0
              this.allList = res.data.data.data
            }
          } else {
            const res = await PostRepository.getReactionsList(2, this.id, null, this.currentPage, 10, null, "alluseful")
            if (res.data.message === "found") {
              // console.log(res.data.data.data)
              this.allCount = res.data.data.paginator.total_count || 0
              this.allList = res.data.data.data
            }
          }
          this.loadingAll = false
          return
      }
    },
    getCount(type) {
      switch (type) {
        case "hcp":
          return 10
        case "doctor":
          return 20
        case "patient":
          return 30
        case "advocate":
          return 40
        case "caregiver":
          return 50
        case "all":
          return 60
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Modals/activity/AnswerReactions.vue